module.exports = __webpack_public_path__ + "static/iron_bands_of_bilarro-a581803c10403b4b789cdd270f379a1a.jpeg";